/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Isctitoolbarenabled5Inputs */

const en_entity_isctitoolbarenabled5 = /** @type {(inputs: Entity_Isctitoolbarenabled5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is CTI Toolbar Enabled`)
};

const de_entity_isctitoolbarenabled5 = /** @type {(inputs: Entity_Isctitoolbarenabled5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CTI-Toolbar aktiviert`)
};

/**
* | output |
* | --- |
* | "Is CTI Toolbar Enabled" |
*
* @param {Entity_Isctitoolbarenabled5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_isctitoolbarenabled5 = /** @type {((inputs?: Entity_Isctitoolbarenabled5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Isctitoolbarenabled5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_isctitoolbarenabled5(inputs)
	return de_entity_isctitoolbarenabled5(inputs)
});
export { entity_isctitoolbarenabled5 as "entity_isCTIToolbarEnabled" }